module.exports = __webpack_public_path__ + "img/uk-blood-diseases-male.fab77494.png";